import React from 'react';

import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './page.component.module.styl';

import type {ReactNode} from 'react';

const classes = hashedClasses(styles);

type PageNavbarProps = {
    /**
     * Navigation items rendered inside the navbar region (e.g. `<NavigationV2>`
     * links or tab controls).
     */
    children: ReactNode,
};

/**
 * Secondary navigation bar rendered just below the `<PageHeader>`.
 *
 * Wraps children in a `<div>` with the `page__navbar` layout class. Use for
 * app-level navigation links or section tabs that should span the full page width.
 */
export const PageNavbar = (props: PageNavbarProps) => <div className={classes.page__navbar}>{props.children}</div>;

PageNavbar.displayName = 'PageNavbar';
